import * as React from "react";
import { ResponsiveContainer, Tooltip, BarChart, CartesianGrid, XAxis, YAxis, Bar, Brush, Legend } from "recharts";
import { CustomTooltipCountries } from "src/share/components/CustomTooltip/CustomTooltip";
import { Col } from "reactstrap";
import { GoogleAnalyticsService } from "src/share/services/ga";
export interface IGACountriesProps {
  pagePath?: string;
  views: {
    query: {
      ids: string
    }
  }
}
export interface IGACountriesState {
  data: any[]
}
export class GACountries extends React.PureComponent<IGACountriesProps, IGACountriesState> {
  public chartNode;
  public chart;

  constructor(props) {
    super(props);
    this.state = {
      data: []
    }
  }
  public componentDidMount() {
    this.getData()
  }
  public componentDidUpdate(prevProps: IGACountriesProps) {
    if (this.props.views.query.ids !== prevProps.views.query.ids || this.props.pagePath !== prevProps.pagePath) {
      this.getData()
    }
  }
  public async getData() {
    const data = await GoogleAnalyticsService.getCountriesInfo(this.props.views.query.ids, this.props.pagePath)
    this.setState({ data })
  }
  public render() {
    return (
      <Col className="col-12 white-background">
        <h5> Last 30 days</h5>
        <h6 className="subtitle">Views by country</h6>
        <ResponsiveContainer width={'90%'} height={310}>
          <BarChart syncId="cityChart" width={730} height={250} data={this.state.data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip content={<CustomTooltipCountries />} />

            {this.state.data.length !== 0 && <Bar dataKey="count" fill="#eab907" />}
            {this.state.data.length === 0 && <Bar dataKey='No data to show' stroke='grey' fill='grey' />}
            {this.state.data.length === 0 && <Legend align="center" verticalAlign="top" layout='horizontal' />}
            <Brush dataKey='name' height={30} stroke="#8884d8" />
          </BarChart>
        </ResponsiveContainer>
      </Col>
    );
  }
}